import React, { Component } from 'react'
import styled from 'styled-components'
import Button from '../Button'

const Panel = styled.div`
  position: fixed;
  background: black;
  width: 100%;
  padding: 2rem;
  text-align: center;
  bottom: 0;
  z-index: 5000;
`

const ButtonWithMargin = styled(Button)`
  margin-right: 4rem;
`

class AuthPanel extends Component {
  goTo(route) {
    this.props.history.replace(`/${route}`)
  }

  login() {
    this.props.auth.login()
  }

  logout() {
    this.props.auth.logout()
  }

  render() {
    const { auth, children } = this.props

    return (
      <Panel>
        {/* <button onClick={this.goTo.bind(this, 'home')}>Home</button> */}
        {!auth.isAuthenticated() && (
          <ButtonWithMargin
            onClick={this.login.bind(this)}
            text="Log In"
            size="small"
            inverse
          />
        )}
        {auth.isAuthenticated() && (
          <React.Fragment>
            <ButtonWithMargin
              onClick={this.logout.bind(this)}
              text="Log Out"
              size="small"
              inverse
            />
            {children}
          </React.Fragment>
        )}
      </Panel>
    )
  }
}

AuthPanel.defaultProps = {
  auth: {
    isAuthenticated: () => false,
  },
}

export default AuthPanel
